import { useState } from 'react';

const useToggle = (defaultOption) => {
   const [toggle, setToggle] = useState(defaultOption ? defaultOption : false);
   const handleToggle = () => setToggle(!toggle);
   return [toggle, handleToggle];
};

export default useToggle;
